import { Checkbox as CheckboxAnt, CheckboxProps } from 'antd'
import { forwardRef } from 'react'
import styled from 'styled-components'

const StyleCheckboxAnt = styled(CheckboxAnt)`
  .ant-checkbox-checked .ant-checkbox-inner::after {
    top: 6px;
  }
  .ant-checkbox-inner {
    border-color: var(--color-primary-primary);
  }
`
interface IProps extends CheckboxProps {
  value?: boolean
  className?: string
  onChange?: (value: any) => void
}

const Checkbox = (props: IProps, ref: any) => {
  const { value, onChange, ...resProps } = props
  const handleOnChange = (e: any) => {
    if (onChange) onChange(e.target.checked)
  }
  return (
    <StyleCheckboxAnt
      {...resProps}
      checked={value}
      ref={ref}
      onChange={handleOnChange}
    />
  )
}

export default forwardRef(Checkbox)
